export const common = {
  nav: {
    home: '홈',
    about: '시설 소개',
    rooms: '객실',
    gallery: '갤러리',
    reservation: '예약',
    access: '오시는 길',
    contact: '문의',
    forOwners: '오너 지원',
    freeConsultation: '무료 상담',
  },
  hero: {
    title: '전통과 현대가 어우러진',
    subtitle: '특별한 숙박 경험',
    description: '도쿄 오타구 마고메에 위치한 전통 일본 고민가 단독 임대. 일본의 전통미와 현대적 편안함이 조화를 이루는 잊지 못할 시간을 보내세요.',
    bookNow: '지금 예약',
    viewGallery: '갤러리 보기',
  },
  about: {
    title: '시설 소개',
    subtitle: '전통 일본 건축의 아름다움과 현대적 편안함의 조화',
    description: '마고메 고민가는 도쿄도 오타구의 조용한 주택가에 위치한 유서 깊은 전통 일본 가옥입니다. 세심하게 리노베이션되어 현대적 편의시설을 갖추면서도 일본 전통의 미의식과 건축 양식을 체험할 수 있는 특별한 공간입니다.',
    feature1Title: '단독 임대',
    feature1Desc: '가족이나 친구들과 프라이빗한 공간에서 여유롭게 즐기세요',
    feature2Title: '풀 키친 완비',
    feature2Desc: '본격적인 요리가 가능한 주방에서 좋아하는 음식을 즐기세요',
    feature3Title: '최대 8명 수용',
    feature3Desc: '넓은 공간으로 그룹 및 가족 숙박에 최적',
    feature4Title: '전통 다다미방',
    feature4Desc: '다다미 향기와 나무의 온기가 가득한 정통 일본식 공간',
  },
  rooms: {
    title: '객실',
    subtitle: '전통 일본식 공간에서 편안한 시간을',
    room1: '평면도',
    room2: '풀 키친',
    room3: '간이 침대',
    capacity: '최대 수용 인원',
    guests: '8명',
    amenities: '시설 및 어메니티',
    amenitiesList: '풀 키친, 냉장고, 전자레인지, 조리도구, 식기, Wi-Fi, 에어컨, 난방, 세탁기, 욕실, 화장실, 수건, 세면도구',
  },
  gallery: {
    title: '갤러리',
    subtitle: '사진으로 느끼는 마고메 고민가의 매력',
  },
  reservation: {
    title: '예약',
    subtitle: '특별한 숙박을 예약하세요',
    name: '성함',
    email: '이메일 주소',
    phone: '전화번호',
    checkin: '체크인',
    checkout: '체크아웃',
    guests: '숙박 인원',
    message: '특별 요청사항',
    submit: '예약 신청 보내기',
    submitting: '전송 중...',
    success: '예약 신청을 받았습니다. 담당자가 곧 연락드리겠습니다.',
    error: '전송에 실패했습니다. 다시 시도해 주세요.',
    bookingPlatforms: '예약 사이트에서도 예약 가능합니다',
    bookOnAirbnb: 'Airbnb에서 빈 방 확인 및 예약',
    bookOnJalan: 'Jalan에서 빈 방 확인 및 예약',
    orDirectBooking: '또는 직접 문의',
    required: '필수',
    guestsPlaceholder: '― 인원 선택 ―',
    guestSingular: '명',
    guestPlural: '명',
    messagePlaceholder: '특별 요청이나 질문이 있으시면 자유롭게 입력해 주세요（500자 이내）',
    confirmNote: '※ 예약 신청 확인 후 담당자가 연락드립니다.',
  },
  contact: {
    title: '문의',
    subtitle: '궁금한 점이나 상담이 있으시면 언제든지 문의해 주세요',
    name: '성함',
    email: '이메일 주소',
    subject: '제목',
    message: '메시지',
    submit: '보내기',
    submitting: '전송 중...',
    success: '문의를 받았습니다. 담당자가 곧 연락드리겠습니다.',
    error: '전송에 실패했습니다. 다시 시도해 주세요.',
    address: '주소',
    addressDetail: '〒143-0022 도쿄도 오타구 히가시마고메 1-12-12',
    access: '오시는 길',
    accessDetail: '도에이 아사쿠사선 「마고메역」에서 도보 8분',
    faqBannerTitle: '제출 전에 자주 묻는 질문을 확인해 주세요',
    faqBannerDesc: '가격, 절차, 운영 관리에 관한 많은 일반적인 질문에 이미 답변했습니다.',
    faqBannerBtn: 'FAQ 보기',
    accessInfoTitle: '오시는 길 안내',
    sendMessageTitle: '메시지 보내기',
    inquiryType: '문의 유형',
    inquiryTypePlaceholder: '문의 유형 선택',
    inquiryOptions: {
      minpaku: '민박 등록 / 허가 신청',
      ryokan: '여관업 라이선스 취득',
      management: '물건 관리 / 운영 대행',
      pricing: '요금 / 플랜',
      marketing: 'Airbnb 리스팅 / 마케팅',
      revenue: '수익 시뮬레이션',
      other: '기타',
    },
    messagePlaceholder: '문의 내용을 입력해 주세요（500자 이내）',
    detailLabel: '상담 내용',
    detailPlaceholder: '물건 위치, 현재 상황, 요청 사항 등을 입력해 주세요（500자 이내）',
  },
  access: {
    label: '오시는 길',
    title: '오시는 길 & 지도',
    subtitle: '도쿄도 오타구 히가시마고메의 조용한 주택가에 위치한 고민가',
    addressLabel: '주소',
    addressLine1: '도쿄도 오타구 히가시마고메 1-12-12',
    addressLine2: '〒143-0022 도쿄도 오타구 히가시마고메 1-12-12',
    trainLabel: '전철 이용',
    trainLine1: '도에이 아사쿠사선 「마고메역」에서 도보 약 2분',
    trainLine2: '',
    busLabel: '버스 이용',
    busLine1: '도에이 버스 「마고메에키마에」 정류장에서 도보 약 2분',
    busLine2: '',
    parkingLabel: '주차장',
    parkingLine1: '근처에 유료 주차장 있음',
    parkingLine2: '차량으로 오시는 경우 미리 문의해 주세요',
    openMap: 'Google 지도에서 열기',
  },
  footer: {
    description: '도쿄 오타구 마고메에 위치한 전통 고민가 단독 임대 숙박시설. 일본의 아름다움과 현대적 편안함이 조화를 이루는 특별한 숙박 경험을 제공합니다.',
    quickLinks: '빠른 링크',
    followUs: '팔로우',
    rights: '모든 권리 보유.',
    napTitle: '요코타 세무회계사무소',
    napAddress: '도쿄도 오타구 히가시마고메 1-12-12',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: '전화: 문의해 주세요',
    napServiceArea: '서비스 지역: 오타구 및 도쿄도 전역',
    napAccess: '도에이 아사쿠사선 「마고메역」 도보권',
  },
  stickyButton: {
    title: '무료 30분',
    subtitle: '상담',
  },
  ownersBanner: {
    subtitle: '도쿄에서 Airbnb를 고려 중인 오너분들께',
    linkText: '오너 지원 서비스 자세히 보기 →',
  },
  airbnbLead: {
    title: '도쿄에서 Airbnb를 시작하고 싶으신가요?',
    description: '민박 등록·여관업 라이선스 취득부터 부동산 관리까지 원스톱으로 지원합니다. 오타구를 거점으로 실제 운영 경험을 바탕으로 한 실용적인 조언을 제공합니다.',
    ctaButton: '무료 상담 신청',
    badge1: '무료·무의무 상담',
    badge2: '실제 운영 경험 보유',
    badge3: '허가 신청부터 관리까지 완전 지원',
  },
  trust: {
    badge: '선택받는 이유',
    title: '도쿄 부동산 오너들의 신뢰',
    subtitle: '실제 운영 경험과 종합적인 지원으로 여러분의 성공을 돕습니다.',
    point1Title: '실제 Airbnb 운영 경험',
    point1Description: '오타구에서 자체 고민가를 실제로 운영하고 있습니다. 이론이 아닌 직접 경험에 기반한 조언을 제공합니다.',
    point2Title: '허가 신청 완전 지원',
    point2Description: '민박 등록부터 여관업 라이선스 취득까지, 서류 작성부터 행정 대응까지 모두 맡겨주세요.',
    point3Title: '수익 극대화 전략',
    point3Description: '도쿄 실제 시장 데이터 기반의 가격 전략. 고객 평균 수익 30% 이상 향상 실적.',
    point4Title: '24시간 게스트 대응',
    point4Description: '다국어 24시간 게스트 지원으로 오너는 수익에만 집중할 수 있습니다.',
    point5Title: '투명한 보고',
    point5Description: '월간 수익 보고서와 명확한 요금 체계. 숨겨진 비용이나 예상치 못한 지출 없음.',
    ctaButton: '서비스 상세 보기',
  },
  howItWorks: {
    title: '이용 흐름',
    subtitle: '상담부터 개업까지, 간단하고 투명한 프로세스',
    step1Number: '01',
    step1Title: '무료 상담',
    step1Desc: '부동산 세부 사항과 목표를 알려주세요. 라이선스 신청, 수익 전망, 다음 단계에 대해 솔직하게 조언해 드립니다.',
    step2Number: '02',
    step2Title: '부동산 조사 및 플랜 작성',
    step2Desc: '부동산 적합성을 평가하고 필요 조건을 확인한 후 맞춤형 액션 플랜을 작성합니다.',
    step3Number: '03',
    step3Title: '개업 및 지속 지원',
    step3Desc: '라이선스 신청부터 게스트 관리까지 모두 맡겨주세요. 오너는 수익에만 집중하세요.',
    ctaButton: '무료 상담 예약',
    ctaNote: '30분 • 무의무 • 명확한 로드맵',
  },
  urgency: {
    title: '도쿄에서 Airbnb를 시작하고 싶으신가요?',
    description: '허가 신청 규칙은 복잡하며 실수하면 개업이 늦어질 수 있습니다. 결정하기 전에 명확하고 실용적인 조언을 받으세요.',
    ctaButton: '무료 상담 예약',
    note: '30분 상담 • 무의무 • 실제 운영 경험 기반',
  },
  trustRisk: {
    title: '부담 없는 무료 상담',
    description: '실제 운영 경험을 바탕으로 실용적인 조언을 제공합니다. 진행하지 않기로 결정하셔도 명확한 로드맵을 드립니다.',
    badge1Title: '무의무',
    badge1Desc: '부담 없는 무료 조언',
    badge2Title: '실제 경험',
    badge2Desc: '자체 부동산을 운영합니다',
    badge3Title: '명확한 로드맵',
    badge3Desc: '바로 활용 가능한 실용적 가이드',
    whatYouGetTitle: '무료 상담에서 얻을 수 있는 것',
    item1: '부동산 잠재력에 대한 솔직한 평가',
    item2: '라이선스 요건 및 일정에 대한 명확한 설명',
    item3: '위치 기반의 현실적인 수익 예측',
    item4: '스스로 실행 가능한 단계별 로드맵',
    ctaButton: '무료 상담 예약',
    ctaNote: '월~금 9:00~18:00 (JST)',
  },
  faq: {
    title: '자주 묻는 질문',
    subtitle: '도쿄에서 Airbnb·민박 사업을 시작하고 운영하는 것에 관한 자주 묻는 질문',
    ctaText: '다른 질문이 있으신가요? 언제든지 문의해 주세요.',
    ctaButton: '무료 상담 예약',
    q1: '도쿄에서 Airbnb를 시작하려면 어떻게 해야 하나요?',
    a1: '도쿄에서 Airbnb를 시작하려면 적절한 라이선스 취득이 필요합니다. 주요 선택지는 두 가지입니다: 민박(주택숙박사업) 등록과 여관업(간이숙소) 라이선스. 민박은 연간 최대 180일 운영 가능하며 지방자치단체에 신고가 필요합니다. 여관업 라이선스는 연중 운영이 가능하지만 더 엄격한 시설 기준과 소방 안전 요건을 충족해야 합니다.',
    q2: '민박과 여관업 라이선스의 차이는 무엇인가요?',
    a2: '민박(주택숙박사업)은 부동산 오너가 연간 최대 180일 자택을 임대할 수 있는 등록 제도입니다. 요건은 간단하지만 운영 일수에 제한이 있습니다. 여관업(간이숙소)은 일수 제한 없이 연중 운영이 가능한 라이선스입니다. 단, 더 엄격한 시설 기준, 소방 설비, 정기 검사가 필요합니다.',
    q3: '외국인도 일본에서 Airbnb를 시작할 수 있나요?',
    a3: '네, 외국인도 일본에서 Airbnb 사업을 시작할 수 있지만 중요한 요건이 있습니다. 일본에서 사업 활동을 허용하는 적절한 체류 자격이 필요하며, 부동산 소유권 또는 유효한 임대 계약이 필요합니다. 또한 문제 발생 시 30분 이내에 대응할 수 있는 일본 거주 관리자를 지정해야 합니다.',
    q4: '도쿄에서 민박 등록은 얼마나 걸리나요?',
    a4: '도쿄에서 민박 등록은 준비 시작부터 승인까지 보통 2~4개월이 걸립니다. 부동산 조사 및 준비(2~3주), 서류 작성 및 소방 검사(2~4주), 지자체 신청(1~2주 심사), 최종 승인 및 등록(1~2주)으로 구성됩니다.',
    q5: '시작하는 데 비용이 얼마나 드나요?',
    a5: '비용은 서비스 범위와 부동산 상태에 따라 다릅니다. 신청 지원, 서류 작성, 현장 조사를 포함한 플랜을 제공합니다. 부동산 관리 서비스는 수익 기반의 성과 보수 체계를 채택하여 초기 비용을 최소화할 수 있습니다.',
    q6: '자체 관리가 어려운 경우 어디까지 대응해 주시나요?',
    a6: '예약 관리, 게스트 대응, 청소 조율, 열쇠 인수인계, 문제 해결, 월간 수익 보고까지 모두 맡겨주실 수 있습니다. 오너는 사실상 손을 놓고 Airbnb 운영이 가능합니다.',
    q7: '아파트에서도 Airbnb를 할 수 있나요?',
    a7: '아파트 관리 규약에서 금지하지 않는 한 Airbnb가 가능합니다. 먼저 관리 규약을 확인하여 숙박이나 단기 임대를 금지하는 조항이 없는지 확인해야 합니다.',
    q8: '이웃 민원이 걱정됩니다. 어떻게 대응하시나요?',
    a8: '게스트에게 명확한 하우스 룰(소음, 쓰레기 처리, 공용 공간 사용 등)을 설정하고 체크인 시 꼼꼼히 설명하여 문제를 사전에 방지합니다. 민원이 발생한 경우 24시간 대응 체계로 신속하게 상황을 파악하고 처리합니다.',
    q9: '어느 정도의 수익을 기대할 수 있나요?',
    a9: '수익은 부동산의 위치, 면적, 시설, 가동률에 따라 크게 다릅니다. 도쿄 인기 지역에서는 1LDK~2LDK 부동산이 월 20만~50만 엔의 수익을 올리는 경우도 있습니다. 과거 운영 데이터를 바탕으로 무료 수익 시뮬레이션을 제공합니다.',
    q10: '상담만 해도 괜찮나요? 계약을 강요받지 않나요?',
    a10: '물론입니다, 상담만으로도 매우 환영합니다. 무료 상담에서는 현재 상황과 질문을 꼼꼼히 듣고 최적의 선택지를 제안하는 것을 최우선으로 합니다. 그 자리에서 계약을 강요하는 일은 절대 없습니다. 본인의 페이스로 결정해 주세요.',
  },
  seo: {
    home: {
      title: '마고메 고민가 | 도쿄 오타구 전통 고민가 단독 임대 & Airbnb 운영 대행',
      description: '도쿄 오타구 마고메의 전통 일본 고민가 단독 임대, 최대 8명 수용. 민박 등록·여관업 라이선스 취득부터 Airbnb 운영 대행까지 현역 호스트가 실무 경험으로 지원합니다.',
      keywords: '마고메 고민가, 도쿄 민박, 오타구 Airbnb, 고민가 단독 임대, 민박 등록 지원',
    },
    management: {
      title: '도쿄 Airbnb 운영 대행 서비스 | 오타구·도쿄 전역 대응',
      description: '도쿄 전문 Airbnb 운영 대행. 게스트 대응·다이나믹 프라이싱·청소 조율·월간 보고서까지 완전 대행. 오타구 거점으로 도쿄 전역 물건 오너를 지원합니다.',
      keywords: 'Airbnb 운영 대행 도쿄, 단기 임대 관리, 오타구 부동산 관리, 게스트 서비스 도쿄',
    },
    support: {
      title: '도쿄 민박·간이숙소 개업 지원 | 여관업 라이선스 신청 대행',
      description: '도쿄 민박·간이숙소 개업을 현역 호스트가 지원. 여관업 라이선스 신청, 민박 신고, 보건소·소방 대응부터 수익화까지 실무 경험에 기반한 확실한 지원을 제공합니다.',
      keywords: '민박 등록 도쿄, 여관업 라이선스 신청, 도쿄 Airbnb 지원, 오타구 단기 임대',
    },
    forOwners: {
      title: '도쿄 Airbnb 운영 대행 & 민박 라이선스 지원 | 물건 오너 전용',
      description: '도쿄 물건 오너를 위한 Airbnb 운영 대행·민박 라이선스 지원. 라이선스 취득부터 일상 운영·청소까지 엔드투엔드 완전 지원. 초회 상담 무료.',
      keywords: '도쿄 Airbnb 오너, 민박 라이선스 지원, 부동산 관리 도쿄, Airbnb 운영 오타구',
    },
    pricing: {
      title: '도쿄 Airbnb 운영 대행 요금 플랜 | 투명한 요금 체계',
      description: '도쿄 Airbnb 운영 대행·민박 지원의 투명한 요금 플랜. 개업 지원·풀 셋업·운영 대행·청소 패키지를 명확한 요금으로 제공. 숨겨진 비용 없음.',
      keywords: 'Airbnb 운영 대행 요금, 민박 지원 비용, 도쿄 단기 임대 플랜, 관리 수수료 도쿄',
    },
    minpakuRegistration: {
      title: '도쿄 민박 등록 가이드 | 여관업 라이선스 신청 단계별 해설',
      description: '도쿄 민박 등록 완전 해설. 여관업 라이선스 신청 전 과정·필요 서류·일정·흔한 실수를 오타구 실제 운영 경험을 바탕으로 상세히 설명합니다.',
      keywords: '민박 등록 도쿄, 여관업 라이선스 신청 도쿄, 도쿄 Airbnb 지원, 오타구 단기 임대',
    },
    guide: {
      title: '도쿄 민박 개업 가이드 2026 | 라이선스 취득부터 수익화까지 완전 해설',
      description: '도쿄에서 Airbnb 비즈니스를 시작하기 위한 완전 가이드. 민박과 여관업 차이, 라이선스 취득 절차, 일정, 흔한 실수, 수익 시뮬레이션, 운영 대행 선택 방법을 해설.',
      keywords: '도쿄 민박 가이드, Airbnb 도쿄 시작, 민박 라이선스, 여관업 라이선스, 도쿄 단기 임대',
    },
    caseStudy: {
      title: '오타구 민박 개업 사례 | 도쿄 Airbnb 성공 케이스 스터디',
      description: '실제 사례: 오타구 물건 오너가 초회 상담부터 3.5개월 만에 첫 예약 획득. 여관업 라이선스 취득, 월수입 18만 엔 이상, 가동률 78% 달성한 도쿄 민박 지원 실적.',
      keywords: '오타구 민박, 도쿄 Airbnb 사례, 여관업 라이선스 도쿄, Airbnb 관리 도쿄',
    },
    adsLanding: {
      title: '도쿄에서 합법적으로 Airbnb 시작하기 | 민박·여관업 라이선스 지원',
      description: '도쿄 민박·여관업 라이선스 취득 전문 지원. 오타구 현역 호스트의 엔드투엔드 Airbnb 운영 대행. 무료 30분 상담 접수 중. 개업 지원 30만 엔~.',
      keywords: '도쿄 Airbnb 합법, 민박 라이선스 지원, 여관업 신청 도쿄, Airbnb 개업 오타구',
    },
    airbnbGuide: {
      title: '도쿄 Airbnb 합법 가이드 | 민박·여관업 라이선스 완전 해설',
      description: '도쿄에서 합법적으로 Airbnb를 시작하기 위한 완전 가이드. 민박 등록·여관업 라이선스 요건, 비용, 일정, 신청 절차를 오타구 실제 운영 경험을 바탕으로 상세히 해설합니다.',
      keywords: 'Airbnb 도쿄 라이선스, 민박 등록 도쿄, 여관업 라이선스 도쿄, Airbnb 운영 대행 도쿄, 오타구 단기 임대',
    },
  },
  schema: {
    management: {
      offerDescription: '월 매출의 15%〜20%',
      service1: '가격 조정・다이나믹 프라이싱',
      service2: '게스트 대응（다국어）',
      service3: '리뷰 관리',
      service4: '청소・린넨 수배',
      service5: '월간 매출 보고서',
      service6: '확정신고 지원 제도',
    },
  },
  taxOffice: {
    badge: '세무회계사무소',
    sectionTitle: '요코타 세무회계사무소',
    sectionSubtitle: '도쿄도 오타구 히가시마고메의 민박 세무 지원 전문가',
    businessName: '요코타 세무회계사무소',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: '소재지',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: '서비스 지역',
    serviceArea: '오타구 및 도쿄도 전역',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: '오시는 길',
    accessJa: '도에이 아사쿠사선 「마고메역」 도보권',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Google 지도에서 열기',
    supportTitle: '민박・Airbnb 세무 지원',
    supportItems: [
      '확정신고 지원 제도 (신고 대리 아님)',
      '오타구 민박 세무 지원',
      '도쿄도 민박 Airbnb 세무 상담',
      '민박 세무 지원 도쿄・초회 상담 무료',
      'Airbnb 세무 상담 도쿄・수익 신고 지원',
    ],
    disclaimer: '※「확정신고 지원 제도」는 신고 서류 작성 보조 및 조언을 의미하며, 세무 대리(신고 대리)와는 다릅니다.',
    officeImageAlt: '요코타 세무회계사무소 — 오타구 히가시마고메의 세무회계사무소',
    officeImageCaption: '요코타 세무회계사무소 — 도쿄도 오타구 히가시마고메',
    officeImageSubCaption: '오타구 민박 세무 지원・Airbnb 세무 상담 도쿄',
  },
  managementContact: {
    title: '무료 상담 양식',
    name: '성함',
    nameRequired: '필수',
    phone: '전화번호',
    email: '이메일 주소',
    emailRequired: '필수',
    propertyType: '물건 유형',
    propertyTypePlaceholder: '선택해 주세요',
    propertyTypeOptions: {
      mansion1k: '아파트（1K〜1LDK）',
      mansion2ldk: '아파트（2LDK 이상）',
      house: '단독주택',
      kominka: '고민가・단독주택',
      taxConsult: '세무 상담',
      other: '기타',
    },
    consultContent: '상담 내용',
    consultContentRequired: '필수',
    consultContentCounter: '{{count}}/500자',
    consultContentPlaceholder: '물건 위치, 현재 상황, 요청 사항 등을 입력해 주세요（500자 이내）',
    submit: '무료 상담 신청（완전 무료）',
    submitting: '전송 중...',
    success: '문의해 주셔서 감사합니다. 2영업일 이내에 연락드리겠습니다.',
    error: '전송에 실패했습니다. 다시 시도해 주세요.',
    beforeContact: '문의 전 안내',
    infoItems: [
      '초회 상담은 완전 무료입니다',
      '도쿄 지역을 중심으로 대응',
      '2영업일 이내 답변',
      '개인정보는 엄격히 관리합니다',
    ],
    recommendTitle: '이런 분께 상담을 권합니다',
    recommendItems: [
      '물건은 있지만 운영이 어려운 분',
      '부업으로 민박을 시작하고 싶은 분',
      '현재 수익에 만족하지 못하는 분',
      '청소 업체를 찾고 있는 분',
      'Airbnb 사용법을 모르는 분',
    ],
    confirmNote: '예약 확인 후 담당자가 연락드립니다.',
  },
  privateDriver: {
    badge: 'Partner Service',
    title: '프라이빗 드라이버',
    titleEn: 'Private Driver Service',
    description: '파트너 드라이버가 공항 픽업부터 관광까지 전문적으로 지원합니다.',
    descriptionHighlight: '영어 가능 드라이버 있음.',
    featureTitle: '서비스 특징',
    features: [
      { title: '영어 가능 드라이버', desc: '해외 게스트를 위한 영어 가능 전문 드라이버.' },
      { title: '안전 보장', desc: '완전 보험 가입 전문 드라이버로 안전하고 편안한 이동을 보장합니다.' },
      { title: '24시간 대응', desc: '이른 아침 항공편이나 심야 도착도 대응. 사전 예약으로 확실히 모십니다.' },
      { title: '대형 짐 OK', desc: '가족용 대형 차량도 준비 가능. 여러 개의 캐리어도 문제없습니다.' },
      { title: '맞춤 루트', desc: '쇼와 레트로 스팟 투어나 촬영 장소로의 특별 루트도 상담 가능합니다.' },
    ],
    menuTitle: '서비스 메뉴',
    priceGuide: '요금 안내',
    pricingTitle: '요금 안내',
    pricingNote: '모두 세금 포함 예상 요금입니다. 자세한 내용은 문의해 주세요.',
    discountBadge: '전용 할인',
    discountTitle: '숙박 게스트 한정',
    discountOff: '10% OFF',
    discountSuffix: '특별 할인',
    discountNote: '예약 시 숙박 사실을 알려주시면 할인 적용됩니다.',
    discountBtn: '지금 예약',
    ctaBadge: 'KOMINKA 게스트 전용',
    ctaTitle: '게스트 전용 특별 요금',
    ctaDesc: 'KOMINKA 숙박 게스트는 프라이빗 드라이버 서비스를 특별 할인으로 이용하실 수 있습니다.',
    ctaBtn: '드라이버 예약',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: '공항 픽업', subtitle: '空港送迎', desc: '하네다/나리타 공항 픽업 & 드롭오프. 미팅 서비스 가능.', price: '¥8,000~' },
      { title: '도쿄 시티 투어', subtitle: '東京観光ドライブ', desc: '현지 드라이버와 함께 쇼와 시대 거리, 사원, 숨겨진 명소 탐방.', price: '¥15,000~/3시간' },
      { title: '장기 체류 지원', subtitle: '長期滞在サポート', desc: '쇼핑, 당일치기 여행, 심부름을 위한 주간 또는 월간 드라이버 서비스.', price: '¥40,000~/주' },
      { title: '촬영 장소 이동', subtitle: '撮影ロケ送迎', desc: '쇼와 시대 명소, 레트로 상점가, 촬영 장소로 이동.', price: '¥12,000~/2시간' },
    ],
    pricing: [
      { title: '공항 픽업', subtitle: 'Airport Transfer', rows: [{ label: '하네다 공항⇔마고메（편도）', price: '¥8,000~' }, { label: '나리타 공항⇔마고메（편도）', price: '¥14,000~' }, { label: '심야/이른 아침 할증（22:00~6:00）', price: '+¥2,000' }, { label: '대형 짐（캐리어 3개 이상）', price: '+¥1,000' }], note: '* 4명까지 동일 요금' },
      { title: '도쿄 시티 투어', subtitle: 'Tokyo City Tour', rows: [{ label: '3시간 코스', price: '¥15,000~' }, { label: '5시간 코스', price: '¥22,000~' }, { label: '종일（8시간）코스', price: '¥35,000~' }, { label: '쇼와 레트로 특별 루트', price: '+¥3,000' }], note: '* 가이드비·주차비 포함' },
      { title: '촬영 장소 이동', subtitle: 'Photo Location Drive', rows: [{ label: '2시간 코스', price: '¥12,000~' }, { label: '4시간 코스', price: '¥20,000~' }, { label: '촬영 스팟 안내 옵션', price: '+¥2,000' }, { label: '장비/대형 짐 대응', price: '+¥1,500' }], note: '* 사전 루트 상담 가능' },
      { title: '장기 체류 지원', subtitle: 'Long Stay Support', rows: [{ label: '주 1회 플랜（월 4회）', price: '¥40,000~' }, { label: '주 2회 플랜（월 8회）', price: '¥72,000~' }, { label: '단발 이용（1회 3시간）', price: '¥12,000~' }, { label: '쇼핑/병원 이동', price: '¥6,000~/회' }], note: '* 월납 10% 할인 적용' },
    ],
  },
};

export default common;
